<template>
  <div class="publication-item">
    <h4>{{ item.title }}</h4>
    <span class="publication-item__info">{{ publicationInfo }}</span>
    <router-link
      class="publication-item__link"
      :to="{ path: `/portal/publication/${item.id}` }"
      target="_blank"
    >
      Читать публикацию
    </router-link>
  </div>
</template>

<script setup>
  import { computed } from 'vue';

  const props = defineProps({
    item: {
      type: Object,
      required: true,
    },
  });

  const publicationInfo = computed(() => {
    return (
      props.item.authors +
      ', ' +
      props.item.status.date +
      ', ' +
      props.item.source
    );
  });
</script>

<style lang="scss" scoped>
  @use '@/assets/styles/_colors' as *;

  .publication-item {
    background: $color-bg-primary-white;
    border-radius: 6px;
    padding: 20px;
    display: flex;
    flex-direction: column;

    h4 {
      margin: 0 0 10px 0;
    }

    &__info {
      margin: 0 0 20px 0;
    }

    &__link {
      color: $color-link-primary;
      text-decoration: underline;
    }
  }
</style>
